import { BarChart, axisClasses } from "@mui/x-charts";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import { withSnackbar } from "../../../../utils/SnackbarHOC";
import { Box, Typography } from "@mui/material";
import { useState } from "react";

const SERIES_TO_METRIC = {
    Sourcing: "Sourcing",
    Envois: "Envoi",
    Révélations: "Révélation",
    Propales: "Propale",
    Signatures: "Signature",
};


const ALL_SERIES = [
    { dataKey: "Sourcing", label: "Sourcé", color: "#02B2AF" },
    { dataKey: "Envois", label: "Envois", color: "#2E96FF" },
    { dataKey: "Révélations", label: "Révélations", color: "#B800D8" },
    { dataKey: "Propales", label: "Propales", color: "#60009B" },
    { dataKey: "Signatures", label: "Signatures", color: "#2731C8" },
];

function MonthlyEvolutionChart({ data, index, onBarClick }) {
  const valueFormatter = (value) => `${value}`;
  const [selectedSeries, setSelectedSeries] = useState(null);

  const chartSetting = {
    yAxis: [
      {
        domain: [0, 500],
      },
    ],
    height: 300,
    sx: {
      [`.${axisClasses.left} .${axisClasses.label}`]: {
        transform: "rotate(-90deg) translate(0px, -20px)",
      },
    },
  };
    const handleLegendClick = (dataKey) => {

        setSelectedSeries((prev) => (prev === dataKey ? null : dataKey));
    };
    const handleItemClick = (event, params) => {
        if (!onBarClick || !params) return;
        const metricType = SERIES_TO_METRIC[params.seriesId];
        const monthKey = data?.[params.dataIndex]?.month;
        if (metricType && monthKey) {
            onBarClick(metricType, monthKey);
        }
    };
    const visibleSeries = ALL_SERIES.filter(
        (s) => selectedSeries === null || s.dataKey === selectedSeries
    ).map((s) => ({
        dataKey: s.dataKey,
        label: s.label,
        color: s.color,
        valueFormatter,
    }));

    return (
        <Box>

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 2,
                    flexWrap: "wrap",
                    mb: 1,
                }}
            >
                {ALL_SERIES.map((s) => {
                    const isDimmed = selectedSeries !== null && selectedSeries !== s.dataKey;
                    return (
                        <Box
                            key={s.dataKey}
                            onClick={() => handleLegendClick(s.dataKey)}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                                cursor: "pointer",
                                opacity: isDimmed ? 0.35 : 1,
                                userSelect: "none",
                            }}
                        >
                            <Box
                                sx={{
                                    width: 14,
                                    height: 14,
                                    borderRadius: "3px",
                                    backgroundColor: s.color,
                                }}
                            />
                            <Typography sx={{ fontSize: 13 }}>{s.label}</Typography>
                        </Box>
                    );
                })}
            </Box>

            <BarChart
                dataset={data}
                xAxis={[{ scaleType: "band", dataKey: "month" }]}
                series={visibleSeries}
                onItemClick={handleItemClick}
                slotProps={{ legend: { hidden: true } }}
                sx={{ "& .MuiBarElement-root": { cursor: "pointer" } }}
                {...chartSetting}
            />
        </Box>
    );
}

export default withRouter(withSnackbar(MonthlyEvolutionChart));

